import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "radio-group",
  role: "radiogroup"
}
const _hoisted_2 = ["value", "checked", "onChange"]
const _hoisted_3 = { class: "radio-icon" }
const _hoisted_4 = {
  key: 0,
  class: "dot"
}
const _hoisted_5 = { class: "label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
      return (_openBlock(), _createElementBlock("label", {
        key: option.value,
        class: _normalizeClass(["radio-card", { active: _ctx.modelValue === option.value }])
      }, [
        _createElementVNode("input", {
          type: "radio",
          class: "radio-input",
          value: option.value,
          checked: _ctx.modelValue === option.value,
          onChange: ($event: any) => (_ctx.onChange(option.value))
        }, null, 40, _hoisted_2),
        _createElementVNode("span", _hoisted_3, [
          (_ctx.modelValue === option.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("span", _hoisted_5, _toDisplayString(option.label), 1)
      ], 2))
    }), 128))
  ]))
}